import { render, staticRenderFns } from "./SmooBtn.vue?vue&type=template&id=0622e36c&"
import script from "./SmooBtn.ts?vue&type=script&lang=ts&"
export * from "./SmooBtn.ts?vue&type=script&lang=ts&"
import style0 from "./SmooBtn.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports